// @ts-check
import fetch from "../../@reditor/frameworks/fetch"

import {keys} from "./keys"
import {GetGlobalResult} from "./types"

/**
 * @param {import('../../@reditor/frameworks/react-query').QueryFunctionContext<
 *    ReturnType<typeof keys.singles>
 * >} context
 */
export async function getGlobal(
  context = {queryKey: keys.singles, meta: undefined},
) {
  const {signal} = context

  const response = await fetch(`/global`, {
    params: {
      fields: [
        "siteTitle",
        "siteDescription",
        "contactEmail",
        "contactLocation",
        "contactPhone",
      ],
      populate: {
        favicon: {
          populate: "*",
        },
        contents: {
          populate: "*",
        },
      },
    },
    signal,
  })
  return GetGlobalResult.parse(response.data)
}
